import { createTab, TabConfig } from '@/components/TabSkeleton'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Tabs, TabsList } from '@/components/ui/tabs'
import { useTranslation } from 'react-i18next'

import MainTab from './MainTab'
import PermissionsTab from './PermissionsTab'

const SettingsContent = () => {
  const { t } = useTranslation()
  const tabConfigs: TabConfig[] = [
    {
      value: 'main',
      title: t('settings.tabs.main'),
      content: <MainTab />,
    },
    {
      value: 'permissions',
      title: t('settings.tabs.permissions'),
      content: <PermissionsTab />,
    },
  ]

  const tabs = tabConfigs.map((config) => createTab(config))

  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle>{t('settings.navigation.settings')}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <Tabs defaultValue="main" className="w-full">
          <TabsList className="w-full">
            {tabs.map((tab) => tab.trigger)}
          </TabsList>

          {tabs.map((tab) => tab.content)}
        </Tabs>
      </CardContent>
    </Card>
  )
}

const SettingsPage = () => {
  return (
    <>
      <SettingsContent />
    </>
  )
}

export default SettingsPage
